import React from "react";
import Grid from "@mui/material/Grid";
export default function DetailTemplate(props: any) {

    return (
        <Grid
            container spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            style={{ marginLeft: '0px' }}
            className="suppliersListDetailContent ">
            <span className="financialListDetailTitle" >
                مشخصات طرح
            </span>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} className="row">
                <Grid item xs={3} md={3} sm={3}
                    // style={{ justifyContent: 'center', display: 'grid' }}
                    style={{
                        position: "relative",
                        // display: "inline-block",
                        lineHeight: "35px",
                        // paddingRight: "45px",
                        paddingTop: "4vh",
                        paddingBottom: "0.1vh",
                        paddingRight: "24px",
                    }}
                // borderLeft: '1px solid #9AAFC4',
                // className="divisionConfirmationCardFinancial"
                >
                    <div>
                        <span style={{ color: "#9AAFC4" }}>نوع طرح فروش:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.loanTemplateTypeTitle}
                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>سود اسمی تسهیلات:</span>
                        <span style={{ color: "#34495E" }}>
                            {props.data?.profitPercentage > 0 ?
                                <>
                                    {" "}
                                    %{props.data?.profitPercentage}
                                </> : "..."
                            }

                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>کمترین سن متقاضی:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.minAgeRestriction}
                            {" سال "}
                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>درصد توان بازپرداخت:</span>
                        <span style={{ color: "#34495E" }}>
                            {props.data?.repaymentPowerPercentage > 0 ?
                                <>
                                    {" "}
                                    %{props.data?.repaymentPowerPercentage}
                                </> :
                                "..."
                            }

                        </span>
                    </div>
                </Grid>
                <Grid item xs={3} md={3} sm={3}
                    // style={{ justifyContent: 'center', display: 'grid' }}
                    style={{
                        position: "relative",
                        // display: "inline-block",
                        lineHeight: "35px",
                        // paddingRight: "45px",
                        paddingTop: "4vh",
                        paddingBottom: "0.1vh",
                        paddingRight: "24px",
                    }}
                    className="divisionConfirmationCardFinancial"


                >
                    <div>
                        <span style={{ color: "#9AAFC4" }}>نوع بازپرداخت :</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.repaymentTypeTitle}
                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>سود واقعی تسهیلات:</span>
                        <span style={{ color: "#34495E" }}>
                            {props.data?.realProfitPercentage > 0 ?
                                <>
                                    {" "}
                                    %{props.data?.realProfitPercentage}
                                </> : "..."
                            }

                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>بیشترین سن متقاضی:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.maxAgeRestriction}
                            {" سال "}
                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}> ارسال پیامک فعال سازی به مشتری:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.needCustomerActivationLoanOtp}
                        </span>
                    </div>

                </Grid>
                <Grid item xs={3} md={3} sm={3}
                    // style={{ justifyContent: 'center', display: 'grid' }}
                    style={{
                        position: "relative",
                        // display: "inline-block",
                        lineHeight: "35px",
                        // paddingRight: "45px",
                        paddingTop: "4vh",
                        paddingBottom: "0.1vh",
                        paddingRight: "24px",
                    }}
                    className="divisionConfirmationCardFinancial"
                >
                    <div>
                        <span style={{ color: "#9AAFC4" }}>تعداد ضامنین:</span>
                        <span style={{ color: "#34495E" }}>
                            {props.data?.guarantorsCount > 0 ?
                                <>
                                    {" "}
                                    {props.data?.guarantorsCount}
                                    {" نفر "}
                                </> :
                                " ندارد "
                            }

                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>کف تسهیلات:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.minAmount.toLocaleString("fa")}
                            {" ریال "}
                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}> نرخ مالیات برارزش افزوده:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            %{props.data?.governmentTaxPercent?.toLocaleString("fa")}

                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}> نوع مجوز افزایش اعتبار:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.creditRequestPermissionTitle}
                        </span>
                    </div>
                    {/* <div>
                        <span style={{ color: "#9AAFC4" }}>درصد تسهیلات:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                        </span>
                    </div> */}
                </Grid>
                <Grid item xs={3} md={3} sm={3}
                    // style={{ justifyContent: 'center', display: 'grid' }}
                    style={{
                        position: "relative",
                        // display: "inline-block",
                        lineHeight: "35px",
                        // paddingRight: "45px",
                        paddingTop: "4vh",
                        paddingBottom: "0.1vh",
                        paddingRight: "24px",
                    }}
                    className="divisionConfirmationCardFinancial"


                >
                    <div>
                        <span style={{ color: "#9AAFC4" }}>تاریخ انقضا:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.expirationDatePersian}
                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>سقف تسهیلات:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.maxAmount.toLocaleString("fa")}
                            {" ریال "}
                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>درصد چک ضمانت:</span>
                        <span style={{ color: "#34495E" }}>
                            <>
                                {" "}
                                %{props.data?.warrantyPercentage}
                            </>

                        </span>
                    </div>
                    <div>
                        {props.data?.maxLoanAmountBasedOnVehiclePricePercentage === 0 ? "" :
                            <>
                                <span style={{ color: "#9AAFC4" }}>درصد تسهیلات نسبت به ارزش خودرو:</span>
                                <span style={{ color: "#34495E" }}>
                                    <>
                                        {" "}
                                        %{props.data?.maxLoanAmountBasedOnVehiclePricePercentage}
                                    </>

                                </span>
                            </>
                        }

                    </div>
                </Grid>
            </Grid>

        </Grid>
    )
}